import React from "react";
import { size } from "lodash";
import { Padder } from "@sonder/ui/source/styled/fragments/Padder";
import { Layout } from "core/components/Layout";
import { FloatingSearchButton } from "search/components/FloatingSearchButton";
import { BulkActionsHeader } from "tasks/components/BulkActionsHeader";
import { AssignedTasks } from "tasks/components/TaskList/AssignedTasks";
import { TaskLists } from "tasks/components/TaskList/TaskLists";
import { TasksHeader } from "tasks/components/TasksHeader";
import { useStore } from "tasks/store";

// Exports
export const TasksView = () => {
  const {
    state: { selectedTasks },
  } = useStore();

  const totalSelectedTasks = size(selectedTasks);
  return (
    <Layout
      pageSubheader={
        totalSelectedTasks > 0 ? (
          <BulkActionsHeader totalSelectedTasks={totalSelectedTasks} />
        ) : (
          <TasksHeader />
        )
      }
      pageTitle="Tasks"
    >
      <AssignedTasks />
      <TaskLists />
      <Padder />
      <FloatingSearchButton />
    </Layout>
  );
};
